import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { IEmbed } from "./interface";
import axiosInstant from "../../../../api";
import { createEmbed } from "../../../../api/endpoints";
import { StoryForm } from "../components/selectedEmbedV2/storyFormCotainer/StoryForm";
// eslint-disable-next-line import/no-cycle
import VideoListingPopup from "../components/selectedEmbedV2/VideoListingPopup";
import { useUser } from "../../../../hooks/useUser";

interface Props {
  refetchEmbeds: () => void;
  onClose: () => void;
  selectedVideos?: Array<number>;
}
export function CreateNewStory({
  refetchEmbeds,
  onClose,
  selectedVideos = [],
}: Props) {
  const { brand } = useUser();
  const brandId: number = brand?.[0]?.id || 0;
  const [, setSearchParams] = useSearchParams();
  const [newEmbed, setNewEmbed] = useState<IEmbed>();
  const [showStoryForm, setShowStoryForm] = useState(false);

  const createEmptyStory = async () => {
    try {
      const response = await axiosInstant.post(createEmbed(), {
        brandId,
        name: `Untitled story ${moment().format("YY-MM-DD")}`,
      });
      setNewEmbed(response.data);

      const { status } = response;
      if (status === 200 || status === 201) {
        toast.success(`Story created successfully.`);
      }

      refetchEmbeds();
      return response.data.id;
    } catch (error) {
      console.log("Error", error);
      return null;
    }
  };

  const onVideoSelectionCompletion = (success?: boolean) => {
    if (success) {
      setShowStoryForm(true);
      refetchEmbeds?.();
    } else onClose();
  };

  const onSettingsDone = () => {
    if (newEmbed?.id) {
      setSearchParams((prev) => {
        prev.set("embed", newEmbed.id.toString());
        return prev;
      });
    }
    onClose();
  };

  if (newEmbed && showStoryForm) {
    return (
      <StoryForm
        embed={newEmbed}
        onComplete={onSettingsDone}
        onClose={onClose}
      />
    );
  }

  return (
    <VideoListingPopup
      createStory={createEmptyStory}
      prevSelectedVideos={selectedVideos}
      onCompletion={onVideoSelectionCompletion}
    />
  );
}
